/* ==========================================================================
   Shopify Forms — Newsletter-Popup Brand Override (Shadow-DOM-Injektion)

   Das Popup rendert die Shopify-Forms-App komplett in einem Shadow Root
   (verifiziert: document.querySelector('[data-sizing="form-wrapper"]') === null).
   Document-CSS kann die Shadow-Grenze nicht überqueren und es gibt keine
   part="..."-Attribute → ::part() scheidet aus. Daher injizieren wir ein
   <style> direkt in den Shadow Root.

   Selektoren ankern auf STABILEN Attributen/Strukturen (data-sizing, data-testid,
   id, aria-label, fieldset/legend/input[type=checkbox]) — NICHT auf den
   CSS-Module-Hashes der App, die bei Updates wechseln. Werte 1:1 aus Brand Kit
   (design-tokens.css) bzw. an bestehende Theme-Components angeglichen
   (.password-form .field__input, .ce-filter-checkbox).

   Fonts ('Pressura', 'Pressura Mono', 'Inter') sind document-weit per @font-face
   registriert und damit auch im Shadow DOM nutzbar. Achtung: in theme.liquid ist
   das Pressura-*Regular*-File als font-weight:500 gemappt (kein 400-Face) →
   Headings/Buttons nutzen weight:500.

   Dark Mode: Theme setzt .dark auf <html>. Da .dark außerhalb des Shadow Roots
   liegt, spiegeln wir den State als Klasse .ce-dark auf den Host und targeten via
   :host(.ce-dark) (cross-browser, im Gegensatz zu :host-context() = nur Chromium).

   Floating-Field-Labels vs. Checkbox-Option-Labels werden getrennt:
   - Feld-Labels:    input[data-testid^="field-"] + label
   - Option-Labels:  fieldset label span
   ========================================================================== */
(function () {
  'use strict';

  var STYLE_ID = 'ce-forms-brand-style';
  var FORM_ANCHOR = '[data-sizing="form-wrapper"]';
  var W = 'section[data-sizing="form-wrapper"]'; // Scope-Prefix

  var CSS = `
    /* ---------- Light ---------- */

    /* Modal: weiße Karte, 16px Radius, 1px Border (Card-Pattern),
       dunkler gerichteter Shadow statt hellem Glow (Brand-elevated war ein Glow). */
    ${W} {
      background:#FFFFFF!important;
      border:1px solid #EDEEEF!important;          /* --ce-border-default */
      border-radius:16px!important;
      box-shadow:0 8px 36px 0 rgba(0,0,0,0.16)!important;
    }

    /* Headline: Pressura 500, größer, mehr Abstand zum Subtext */
    ${W} h2 {
      font-family:'Pressura',sans-serif!important;
      font-weight:500!important;                   /* H2-Brand-Weight = Regular-Face */
      font-size:30px!important;
      line-height:1.15!important;
      color:#18191A!important;                      /* --ce-text-heading */
      margin:0 0 14px!important;
    }

    /* Subtext: Inter, Orphan ("Kaffeebestellung") via balance entschärfen */
    ${W} section p {
      font-family:'Inter',sans-serif!important;
      color:#575A61!important;                       /* --ce-text-secondary */
      text-wrap:balance!important;
    }

    /* Inputs: grauer Fill, KEIN Rahmen (wie übrige Shop-Felder), 8px Radius */
    ${W} input[data-testid^="field-"] {
      font-family:'Inter',sans-serif!important;
      background:#F3F3F3!important;                 /* --ce-surface-muted */
      border:none!important;
      border-radius:8px!important;
      color:#313337!important;                       /* --ce-text-body */
    }
    ${W} input[data-testid^="field-"]:focus {
      box-shadow:0 0 0 1px #18191A!important;         /* Theme-Input-Focus-Pattern (1px) */
      outline:none!important;
    }

    /* Floating-Field-Labels → Pressura Mono (Theme-Label-Konvention) */
    ${W} input[data-testid^="field-"] + label {
      font-family:'Pressura Mono',sans-serif!important;
      color:#69727D!important;                       /* --ce-text-tertiary */
    }

    /* Choice-Field "Wofür interessierst du dich?" — Spacing oben/unten */
    ${W} fieldset {
      border:0!important;
      margin:8px 0!important;
      padding:0!important;
    }
    ${W} fieldset legend {
      font-family:'Pressura Mono',sans-serif!important;
      font-weight:500!important;
      font-size:14px!important;
      color:#18191A!important;                        /* --ce-text-heading */
      margin:0 0 12px!important;
      padding:0!important;
    }
    ${W} fieldset > div {
      display:flex!important;
      flex-direction:column!important;
      gap:8px!important;
    }
    ${W} fieldset label {
      display:flex!important;
      align-items:center!important;
      gap:8px!important;
      cursor:pointer!important;
    }
    ${W} fieldset label span {
      font-family:'Inter',sans-serif!important;
      color:#18191A!important;                        /* --ce-text-heading */
    }

    /* Checkbox = .ce-filter-checkbox (kein blaues Default-Styling) */
    ${W} fieldset input[type="checkbox"] {
      appearance:none!important;-webkit-appearance:none!important;
      width:16px!important;height:16px!important;min-width:16px!important;
      flex-shrink:0!important;
      border:1px solid #D1D1D4!important;            /* --ce-border-strong */
      border-radius:4px!important;
      background:#FFFFFF!important;
      position:relative!important;
      margin:0!important;cursor:pointer!important;
      transition:border-color 200ms ease,background-color 200ms ease!important;
    }
    ${W} fieldset input[type="checkbox"]:hover {
      border-color:#18191A!important;
    }
    ${W} fieldset input[type="checkbox"]:checked {
      background:#18191A!important;border-color:#18191A!important;
    }
    ${W} fieldset input[type="checkbox"]:checked::after {
      content:''!important;position:absolute!important;
      top:1px!important;left:4px!important;
      width:5px!important;height:8px!important;
      border:solid #FFFFFF!important;
      border-width:0 1.5px 1.5px 0!important;
      transform:rotate(45deg)!important;
    }

    /* Submit-Button: Pressura Mono, dunkel, 8px */
    ${W} [data-testid="btn-form-submit"] {
      font-family:'Pressura Mono',sans-serif!important;
      font-weight:500!important;
      font-size:15px!important;
      border-radius:8px!important;
      background:#18191A!important;                  /* --ce-surface-invert */
      color:#FFFFFF!important;                        /* --ce-text-on-invert */
      border:none!important;
    }
    ${W} [data-testid="btn-form-submit"]:hover {
      background:#313337!important;                  /* --ce-surface-invert-hover */
    }

    /* Disclaimer: linksbündig, mehr Abstand zum Button */
    ${W} [data-testid="form"] ~ div {
      margin-top:20px!important;
    }
    ${W} [data-testid="form"] ~ div p {
      font-family:'Inter',sans-serif!important;
      color:#69727D!important;                        /* --ce-text-tertiary */
      text-align:left!important;
    }

    /* Close-X: Brand-Grau, Hover dunkler, sichtbarer Focus (a11y) */
    ${W} [aria-label="Close modal"] svg path {
      fill:#575A61!important;                          /* --ce-text-secondary */
    }
    ${W} [aria-label="Close modal"]:hover svg path {
      fill:#18191A!important;                          /* --ce-text-heading */
    }
    ${W} [aria-label="Close modal"]:focus-visible {
      outline:2px solid #18191A!important;
      outline-offset:2px!important;
    }

    /* ---------- Dark (Host trägt .ce-dark, gespiegelt von html.dark) ---------- */

    :host(.ce-dark) ${W} {
      background:#232528!important;                  /* --ce-surface-card (dark) */
      border-color:#454850!important;                /* --ce-border-default (dark) */
      box-shadow:0 8px 36px 0 rgba(0,0,0,0.5)!important;
    }
    :host(.ce-dark) ${W} h2 {
      color:#FBFBFC!important;                         /* --ce-text-heading (dark) */
    }
    :host(.ce-dark) ${W} section p {
      color:#B6B7BB!important;                         /* --ce-text-secondary (dark) */
    }
    :host(.ce-dark) ${W} input[data-testid^="field-"] {
      background:#313337!important;                   /* --ce-surface-muted (dark) */
      color:#EDEEEF!important;                         /* --ce-text-body (dark) */
    }
    :host(.ce-dark) ${W} input[data-testid^="field-"]:focus {
      box-shadow:0 0 0 1px #FBFBFC!important;
    }
    :host(.ce-dark) ${W} input[data-testid^="field-"] + label {
      color:#69727D!important;                         /* --ce-text-tertiary (dark) */
    }
    :host(.ce-dark) ${W} fieldset legend {
      color:#FBFBFC!important;                         /* DF2: war zuvor dunkel */
    }
    :host(.ce-dark) ${W} fieldset label span {
      color:#EDEEEF!important;                         /* --ce-text-body (dark) */
    }
    :host(.ce-dark) ${W} fieldset input[type="checkbox"] {
      background:#313337!important;                   /* --ce-surface-muted (dark) */
      border-color:#575A61!important;                 /* --ce-border-strong (dark) */
    }
    :host(.ce-dark) ${W} fieldset input[type="checkbox"]:hover {
      border-color:#FBFBFC!important;
    }
    :host(.ce-dark) ${W} fieldset input[type="checkbox"]:checked {
      background:#FBFBFC!important;border-color:#FBFBFC!important;  /* invertiert */
    }
    :host(.ce-dark) ${W} fieldset input[type="checkbox"]:checked::after {
      border-color:#18191A!important;                 /* dunkler Haken auf hellem Feld */
    }
    :host(.ce-dark) ${W} [data-testid="btn-form-submit"] {
      background:#FBFBFC!important;                   /* --ce-surface-invert (dark) — invertiert */
      color:#18191A!important;                         /* --ce-text-on-invert (dark) */
    }
    :host(.ce-dark) ${W} [data-testid="btn-form-submit"]:hover {
      background:#EDEEEF!important;                   /* --ce-surface-invert-hover (dark) */
    }
    :host(.ce-dark) ${W} [data-testid="form"] ~ div p {
      color:#69727D!important;                         /* --ce-text-tertiary (dark) */
    }
    :host(.ce-dark) ${W} [aria-label="Close modal"] svg path {
      fill:#B6B7BB!important;                          /* --ce-text-secondary (dark) */
    }
    :host(.ce-dark) ${W} [aria-label="Close modal"]:hover svg path {
      fill:#FBFBFC!important;                          /* --ce-text-heading (dark) */
    }
    :host(.ce-dark) ${W} [aria-label="Close modal"]:focus-visible {
      outline-color:#FBFBFC!important;
    }
  `;

  var hosts = [];

  function syncDark(host) {
    var dark = document.documentElement.classList.contains('dark');
    host.classList.toggle('ce-dark', dark);
  }

  function inject(host) {
    var root = host.shadowRoot;
    if (!root) return false;
    if (!root.querySelector(FORM_ANCHOR)) return false; // Form noch nicht gemountet
    if (!root.getElementById(STYLE_ID)) {
      var style = document.createElement('style');
      style.id = STYLE_ID;
      style.textContent = CSS;
      root.appendChild(style);
    }
    syncDark(host);
    return true;
  }

  function trackHost(host) {
    if (host.__ceFormsTracked || !host.shadowRoot) return;
    host.__ceFormsTracked = true;
    hosts.push(host);

    inject(host);

    // Re-Inject, falls die App das <style> bei Re-Render entfernt;
    // fängt zugleich das verspätete Mounten der Form im Shadow Root.
    // Anti-Loop (CLAUDE.md #9): vor eigener Mutation disconnect, danach reconnect.
    var obs = new MutationObserver(function () {
      obs.disconnect();
      inject(host);
      obs.observe(host.shadowRoot, { childList: true, subtree: true });
    });
    obs.observe(host.shadowRoot, { childList: true, subtree: true });
  }

  function scanFor(el) {
    if (el && el.shadowRoot) trackHost(el);
    if (el && el.querySelectorAll) {
      el.querySelectorAll('*').forEach(function (n) {
        if (n.shadowRoot) trackHost(n);
      });
    }
  }

  function init() {
    scanFor(document.body);

    // Popup-Host wird dynamisch in den Body gehängt → beobachten.
    // (Shadow-interne Mutationen sieht dieser Observer NICHT — die fängt
    //  der pro-Host-Observer in trackHost ab.)
    new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        m.addedNodes.forEach(function (n) {
          if (n.nodeType === 1) scanFor(n);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });

    // Dark-State von <html> auf alle bekannten Hosts spiegeln.
    new MutationObserver(function () {
      hosts.forEach(syncDark);
    }).observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
